module.exports = __webpack_public_path__ + "img/planet-neptune.267bf960.svg";